export default "__VITE_ASSET__BJ$DH_gO__"